<template>
  <div class="page-explore" id="explore">
    <rebuild-nav-bar></rebuild-nav-bar>
    <div class="content-wrapper">
      <div class="filter-bar-s2">
        <div class="filter-bar-wrapper">
          <div class="filter-btn" @click="handleClickItem(1)">
            <div class="select-control">{{ topicVal }}</div>
          </div>
          <div class="filter-btn" @click="handleClickItem(2)">
            <div class="select-control">{{ tagVal }}</div>
          </div>
        </div>
      </div>
      <!--  -->
      <div v-if="projectsData.length > 0" class="funding-container">
        <div class="project-list-container">
          <div class="project-list clearfix mt20">
            <project-item
              v-for="item of projectsData"
              :key="item.id"
              :projectData="item"
              :hasTags="true"
              :hasDesc="true"
              :hasProcess="true"
              :hasLink="true"
              :hasTheme="true"
              :isAnnouncement="false"
              :isWeekly="false"
            ></project-item>
          </div>
        </div>

        <div class="foot-btn-area">
          <div class="panel-footer-more" v-if="hasMoreData">
            <span class="text" @click="loadMore">加载更多+</span>
          </div>

          <!-- 造1 -->
          <!-- 造1 -->
          <div class="create_btn_s1" @click="bindToCreation"># 造一个夜计划 #</div>
          <div style="height: 58px"></div>
        </div>
      </div>

      <div v-else class="project-nodata" :style="{ backgroundImage: 'url(' + pageBg + ')' }">
        <div class="tips">没有适合你的搜索结果，</div>
        <div class="tips">换组标签再试试？</div>

        <button class="button reset-filter-btn" @click="resetFilter">
          <span class="iconfont icon-close-circle"></span>
          重置页面
        </button>
      </div>
    </div>

    <div class="scroll-top-s2" @click="scrollToTop">
      <img src="~@static/funding/icon-top.png" />
    </div>

    <fill-modal :isShow.sync="isShow" @cancel="fillModalCancel" @confirm="fillModalConfirm" :maskClick="true">
      <div class="profile-datepicker" v-if="selectType === 1">
        <div class="modal-title">请选择主题</div>
        <div class="datepicker-wrap">
          <van-picker ref="topicPicker" item-height="7.4666vw" :columns="columns_topic" columns-num="1" visible-item-count="3" @change="handleTopicChange" />
        </div>
      </div>
      <div class="profile-datepicker" v-if="selectType === 2">
        <div class="modal-title">请选择关键字</div>
        <div class="datepicker-wrap">
          <van-picker ref="tagPicker" item-height="7.4666vw" :columns="columns_tag" columns-num="1" visible-item-count="3" @change="handleTagChange" />
        </div>
      </div>
      <div class="profile-datepicker" v-if="selectType === 3">
        <div class="modal-title">请选择你所在的省份</div>
        <div class="datepicker-wrap">
          <van-picker item-height="7.4666vw" :columns="columns" columns-num="2" visible-item-count="3" @change="handleCityChange" />
        </div>
      </div>
    </fill-modal>
  </div>
</template>

<script>
import RebuildNavBar from '@components/RebuildNavBar'
import ProjectItem from './components/ProjectItemCpunk'
import StatisticsBar from './components/StatisticsBar'
import { mapState } from 'vuex'
import { verify, tools } from '@/utils'
import StepBtn from './components/StepBtn'
import FillModal from './components/FillModal'
import provinces from '@javascripts/cities.js'

export default {
  name: 'Explore',
  components: {
    RebuildNavBar,
    StatisticsBar,
    ProjectItem,
    StepBtn,
    FillModal,
  },
  data() {
    return {
      pageBg: '',
      totalProject: 0,
      projectsData: [],
      hasMoreData: true,
      filterParam: {
        topic: 0,
        tag: 0,
        page: 1,
        new: 1,
        'per-page': 12,
        province: '',
      },
      // 显示
      topicVal: '主题',
      tagVal: '关键字',
      canLoad: true,
      // 临时
      selectTopic: { id: 0, text: '主题' },
      selectTag: { id: 0, text: '关键字' },
      columns_topic: [],
      columns_tag: [],
      isShow: false,
      selectType: 0,
      isWinner: false,
      // 城市
      columns: [],
      selectProvince: ['河北省', '石家庄市'],
    }
  },
  computed: {
    ...mapState(['authorization']),
    pickerItemHeight() {
      return (56 / (375 * 2)) * 100 + 'vw'
    },
  },
  created() {
    let { path_from } = this.$route.query
    if (path_from === 'winner') {
      this.isWinner = true
      this.filterParam.topic = 10
      this.filterParam.plan_status = 2
    }
    this.initProvince()
  },
  mounted(options) {
    let province = this.$route.query.province
    if (province) {
      this.filterParam.province = province
    }
    //
    this.getFundingData()
    this.requestTags()
    this.requestTopicsList()
    // 分享
    if (verify.isWeixin()) {
      let shareInfo = {
        title: '绝对夜计划',
        desc: '绝对赛博夜计划，最高赢取5万元派对金，邀你一起造',
        imgUrl: this.$apiConfig.domain + '/static/funding_cpunk/share.png?v=1',
      }
      let p = tools.parseParams(this.$route.query)
      this.WXConfig.wxShowMenu(`${this.$apiConfig.domain}/welcome?${p}`, shareInfo)
    }
  },
  methods: {
    initProvince: function () {
      let mapData = []
      provinces.citiesData.provinces.forEach(item => {
        let obj = {
          text: item.provinceName,
          children: item.citys.map(item2 => {
            return {
              text: item2.citysName,
            }
          }),
        }
        mapData.push(obj)
      })
      this.columns = mapData
    },
    getFundingData() {
      this.$request
        .get(this.$apiConfig.newPlansUrl, {
          params: this.filterParam,
        })
        .then(this.handleGetFundingDataSucc)
    },

    requestTags: function () {
      this.$request
        .get(this.$apiConfig.tagsUrl, {
          'per-page': 50,
        })
        .then(res => {
          let resData = res.data
          if (resData.code == 0 && resData.data) {
            let mapData = [{ id: 0, text: '关键词' }]
            resData.data.items.forEach(item => {
              let obj = {
                text: item.name,
                id: item.id,
              }
              mapData.push(obj)
            })
            this.columns_tag = mapData
          } else {
            console.log(res.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    requestTopicsList: function () {
      this.$request
        .get(this.$apiConfig.topicsUrl, { type: 'all' })
        .then(res => {
          let resData = res.data
          if (resData.code == 0 && resData.data) {
            let mapData = [{ id: 0, text: '主题' }]
            resData.data.items.forEach(item => {
              let obj = {
                text: item.title,
                id: item.id,
              }
              mapData.push(obj)
            })
            this.columns_topic = mapData
          } else {
            console.log(res.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    handleGetFundingDataSucc(res) {
      let resData = res.data
      if (resData.code == 0 && resData.data) {
        const data = resData.data
        this.totalProject = data._meta.totalCount
        let pageCount = data._meta.pageCount
        if (this.filterParam.page == 1) {
          this.projectsData = []
          this.filterParam.page = 1
        }
        if (!!data.items && data.items.length > 0) {
          let _items = data.items
          this.projectsData = this.projectsData.concat(_items)
          if (this.filterParam.page == pageCount) {
            this.hasMoreData = false
          } else {
            if (_items.length < this.perPage) {
              this.hasMoreData = false
            } else {
              this.filterParam.page += 1
              this.hasMoreData = true
            }
          }
        } else {
          this.hasMoreData = false
        }
        this.canLoad = true
      }
    },
    resetFilter() {
      if (this.isWinner) {
        this.filterParam.topic = 10
        this.filterParam.plan_status = 2
        this.filterParam.province = ''
      } else {
        this.filterParam.topic = 0
        this.filterParam.tag = 0

        this.topicVal = '主题'
        this.tagVal = '关键字'
      }

      this.filterParam.page = 1
      this.filterParam['per-page'] = this.perPage
      this.getFundingData()
    },
    fillModalCancel() {},
    fillModalConfirm() {
      if (this.selectType === 1) {
        this.filterParam.topic = this.selectTopic.id
        this.topicVal = this.selectTopic.text
      }
      if (this.selectType === 2) {
        this.filterParam.tag = this.selectTag.id
        this.tagVal = this.selectTag.text
      }
      if (this.selectType === 3) {
        this.filterParam.province = this.selectProvince[1]
      }
      this.filterParam.page = 1
      this.filterParam['per-page'] = this.perPage
      this.getFundingData()
    },
    handleClickItem(type) {
      this.selectType = type
      this.isShow = true
      this.$nextTick(() => {
        if (type === 1) {
          let i = this.columns_topic.findIndex(item => {
            return item.text === this.topicVal
          })
          this.$refs.topicPicker.setIndexes([i])
        }
        if (type === 2) {
          let i = this.columns_tag.findIndex(item => {
            return item.text === this.tagVal
          })
          this.$refs.tagPicker.setIndexes([i])
        }
      })
    },
    handleTopicChange(picker, value, index) {
      this.selectTopic = value
    },
    handleTagChange(picker, value, index) {
      this.selectTag = value
    },
    loadMore() {
      if (this.hasMoreData && this.canLoad) {
        this.canLoad = false
        this.getFundingData()
      }
    },
    bindToCreation(to) {
      this.$router.push('/fundingnew/creation')
      // _jcq.push(['_track', 'yjhbccreate'])
    },
    scrollToTop: function (e) {
      document.querySelector('#explore').scrollTop = 0
    },
    reset: function () {
      this.filterParam.province = ''
      this.filterParam.page = 1
      this.filterParam['per-page'] = this.perPage
      this.getFundingData()
    },
    handleCityChange(picker, value, index) {
      this.selectProvince = value
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/cpunk.scss';

.page-explore {
  height: 100%;
  overflow: auto;
  padding-bottom: 60px;
  @include respond-to(iphonex) {
    padding-bottom: 85px;
  }
}

.filter-bar-s2 {
  width: pxtow(650);
  height: pxtow(75);
  padding: 0 pxtow(20);
  white-space: nowrap;
  background: #fd0fff;
  border: 2px solid #fff;
  border-radius: pxtow(40);
  margin: 0 auto;
  position: relative;
  .filter-bar-wrapper {
    display: flex;
    align-items: center;
    height: pxtow(75);
  }
  .filter-btn {
    position: relative;
    width: 49%;
    padding: 0 10px;
    border-radius: 5px;
    font-weight: 700;
    font-size: 11px;
    overflow: hidden;
    cursor: pointer;
    .select-control {
      &:after {
        content: '';
        display: block;
        width: 12px;
        height: 12px;
        background: url(~@static/fundingnew_/home/icon-arrow-white.png) 50% 50% no-repeat;
        background-size: contain;
        position: absolute;
        z-index: 1;
      }
    }
    &.active {
      color: #fff;
      border-color: #fff;
    }
  }
}

.cp_list1 {
  margin-top: pxtow(60);
}
.content-wrapper {
  min-height: pxtow(1536);
  padding-top: pxtow(40);
  background: url(~@static/funding_cpunk/home/bg.jpg) 0% 0 repeat-y;
  background-attachment: fixed;
  background-size: 100% auto;
  position: relative;
}
.project-list {
  @include respond-to(desktop) {
    @include display-flex;
    justify-content: start;
    flex-wrap: wrap;
  }
}
.project-list /deep/ .project-item {
  margin-bottom: 40px;
}
.project-nodata {
  // position: absolute;
  z-index: 1;
  top: 65px;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 80px 0;
  text-align: center;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  @include respond-to(desktop) {
    padding: 200px 0;
  }
  .tips {
    font-weight: bold;
    font-size: 1.5rem;
    color: #fff;
  }
}
.reset-filter-btn {
  display: inline-block;
  margin-top: 30px;
  height: 35px;
  line-height: 1.1;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 5px;
  font-weight: bold;
  font-size: 1.5rem;
  color: #fff;
  background-color: transparent;
  .iconfont {
    margin-right: 6px;
  }
}
.page-foot-img {
  width: 100%;
  height: auto;
  bottom: 0;
  left: 0;
  position: absolute;
}

.panel-footer-more {
  margin-bottom: pxtow(60);
  font-size: (22/7.5) * 1vw;
  text-align: center;
  span {
    padding: (10/7.5) * 1vw;
  }
}
.foot-btn-area {
  padding: pxtow(60) 0 pxtow(120);
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/Explore.vue